import clsx from "clsx";
import { NavLink } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { Fragment } from "react";

export type FPBreadcrumb = {
  // Display label for the breadcrumb
  label: string;

  // The href attribute for the breadcrumb's link, if any
  href?: string;
  search?: string;

  disabled?: boolean;
};

export type FPBreadcrumbsProps = {
  breadcrumbs: FPBreadcrumb[];
};

/**
 * Navigational breadcrumbs styled to Freshpaint's design system.
 */
function FPBreadcrumbs({ breadcrumbs }: FPBreadcrumbsProps) {
  if (breadcrumbs.length === 0) {
    return null;
  }

  return (
    <div aria-label="breadcrumb" className="flex items-center gap-2">
      {breadcrumbs.map((b, i) => {
        const disabled = b.disabled || !b.href || b.href === "#";
        return (
          <Fragment key={`${i}-${b.href}`}>
            {i > 0 && <ChevronRight className="text-textSubtle" size={16} />}
            <NavLink
              exact
              to={{ pathname: b.href, search: b.search }}
              key={`${b.label}-${b.href}`}
              className={(active) =>
                clsx(
                  "py-2 text-[13px] font-bold focus:rounded-sm focus:outline-3 focus:outline-blue-100",
                  active
                    ? "text-textDefault"
                    : "text-textSubtle hover:text-textDefault underline",
                  disabled &&
                    "pointer-events-none !no-underline focus:outline-none",
                )
              }
            >
              {b.label}
            </NavLink>
          </Fragment>
        );
      })}
    </div>
  );
}

export default FPBreadcrumbs;
